<template>
  <collapse>
    <collapse-item title="Повтор при ошибки или молчании" class="second-layer">
      <div>
        <p class="control">
          <label><input type="radio" :name="stateName+'_generateState'" v-model="repeatData.generationState" value="url"/>Url аудио</label>
          <label><input type="radio" :name="stateName+'_generateState'" v-model="repeatData.generationState" value="load"/>Загрузить аудио</label>
          <label><input type="radio" :name="stateName+'_generateState'" v-model="repeatData.generationState" value="text"/>Сгенерировать аудио</label>
        </p>
      </div>
      <span>Выбрано: {{ repeatData.generationState }}</span>
      <div v-if="repeatData.generationState === 'url'">
        <input type="url" class = "input url audioUrl" v-model="repeatData.questionAudio" placeholder="Url of audio"/>
        <audio v-if="repeatData.questionAudio">
          <source v-bind:src="repeatData.questionAudio">
          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
        </audio>
        <audio-player v-if="repeatData.questionAudio" :file="repeatData.questionAudio"/>
      </div>
      <div v-if="repeatData.generationState === 'text'">
        <p class="control">
          <textarea v-model="repeatData.questionText" class="textarea"></textarea>
          <div class="control is-grouped">
            <button class="button is-primary" v-on:click="genAudio()">
                  <span class="icon">
                    <i class="fa fa-magic"></i>
                  </span>
<!--              <div class="loader spinner" v-if="tmp.questionSecondNoYesLoading"></div>-->
              Сгенерировать аудио
            </button>

            <div class="select is-primary">
              <select v-model="repeatData.currentSpeaker" class="form-control">
                <option v-for="speaker in speakerList">
                  {{speaker.value}}
                </option>
              </select>
            </div>
            <div class="select is-primary">
              <select v-model="repeatData.currentEmotion" class="form-control">
                <option v-for="emotion in emotionList">
                  {{emotion.value}}
                </option>
              </select>
            </div>
          </div>
        <p>
          <slider size="small" v-bind:value="repeatData.currentSpeed" :min="0.1" :step="0.1" :max="3" @change="repeatData.currentSpeed = $event"></slider>
          Скорость:&nbsp{{repeatData.currentSpeed}}
        </p>

        <audio v-if="repeatData.questionAudio">
          <source v-bind:src="repeatData.questionAudio">
          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
        </audio>
        <audio-player v-if="repeatData.questionAudio" :file="repeatData.questionAudio"/>
      </div>
      <div v-if="repeatData.generationState === 'load'">
          <p class="control">
          <div class="control">
            <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile()">
            <input style="display:none;" @input="loadAudio()" name="load-audio" type="file" accept=".wav,.mp3">
            <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal()">
            <audio v-if="repeatData.questionAudio">
              <source v-bind:src="repeatData.questionAudio">
              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
            </audio>
            <audio-player v-if="repeatData.questionAudio" :file="repeatData.questionAudio"/>
          </div>
        </div>
    </collapse-item>
  </collapse>
</template>

<script>
  import Cleave from 'vue-cleave'
  import AudioPlayer from '../../../components/audio-player.vue'
  import Notification from 'vue-bulma-notification'
  import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse'
  import Message from 'vue-bulma-message'
  import Modal from '../ModalAudio'
  import Slider from 'vue-bulma-slider'
  export default {
      name: 'GenerateRepeatAudio',
      props: ['repeatData', 'speakerList', 'emotionList', 'stateName'],
      components: {
        Modal,
        Cleave,
        AudioPlayer,
        Message,
        Notification,
        Collapse,
        CollapseItem,
        Slider
      }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// GenerateRepeatAudio.vue?fc2cd9a6